/**
 * How a workspace's product kind is written for a human (#3561).
 *
 * Lifted out of `workspace-company-table.tsx` so the Workspaces list and the
 * maintenance notice cannot disagree about what `training-agent` is called. Two
 * copies of a label map is how the same workspace ends up reading "Training" on
 * one screen and "training-agent" on the next.
 *
 * An unknown kind falls through to the raw wire value rather than a blank or an
 * "Other": a product we have not catalogued yet still belongs to a real
 * customer, and its name is more useful than a shrug.
 */
export function companyTypeLabel(type?: string | null): string {
    switch (type) {
        case "hr_screening":
            return "HR Screening";
        case "agent_calling":
            return "Agent Calling";
        case "training-agent":
            return "Training";
        case "oura":
            return "Oura";
        // A WhatsApp AI Receptionist merchant workspace (ourteam-frontend#3612,
        // ourteam-backend#4670) — the same shape as "oura".
        case "receptionist":
            return "Receptionist";
        default:
            return type || "";
    }
}
